var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");

var AbstractViewerController = require("./../../abstractViewerController.js");

var EllipseInteractionView = require("./ellipseInteractionView.js");
var EllipseInteractionModel = require("./ellipseInteractionModel.js");

var EllipseViewerController = function(archLayers, dependencies, configuration) {
    AbstractViewerController.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(EllipseViewerController, AbstractViewerController);
EllipseViewerController.inject = AbstractViewerController.inject;

module.exports = EllipseViewerController;

EllipseViewerController.prototype.beforeLoad = function () {
    AbstractViewerController.prototype.beforeLoad.call(this);
};

EllipseViewerController.prototype.getDataType = function () {
    return cio_datamodel.EllipseData;
};

EllipseViewerController.prototype.getInteractionViewType = function () {
    return EllipseInteractionView;
};

EllipseViewerController.prototype.getInteractionModelType = function () {
    return EllipseInteractionModel;
};
